<template>
  <div class="cbox JobContainer">

    <iframe v-if="type"
            id="iframepage"
            style="width:100%;height:100%;border:0;"
            :src="url" allowfullscreen allow="fullscreen"></iframe>

  </div>
</template>
<script>

export default {
  name: 'deptRole',
  data() {
    return {
      type: "",
      url:"",
      rootUrl: '//qsxdata.qushixi.org.cn/#/singleapp',
      token: ""
    }
  },
  mounted() {
    this.type = this.$route.params.type;
    this.getToken()
  },
  methods: {
    getToken() {
      this.$http.post('/api/get_jyj_auth').then(res => {
        this.token = res.data.token;
        this.url = this.rootUrl + `/${this.type}?auth=${res.data.token}`
      }).catch(() => {
        this.url = ""
      })
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.type = to.params.type;
    this.url = this.rootUrl + `/${to.params.type}`
    next()
  },
}
</script>
<style type="text/less" scoped>
</style>
